import { GetPlacesByBoundingBoxRequest } from '../../api/requests/place-request.ts';
import { useQuery } from '@tanstack/react-query';
import { getPlacesByBoundingBox } from '../../api/place.ts';

export default function useSearchPlacesByBoundingBox(
  query: GetPlacesByBoundingBoxRequest,
) {
  const { data, isLoading, error, isPlaceholderData } = useQuery({
    queryKey: ['places', query],
    queryFn: () => getPlacesByBoundingBox(query),
    placeholderData: (previousData) => previousData,
    enabled:
      !!query.minLat && !!query.minLng && !!query.maxLat && !!query.maxLng,
  });

  return {
    data,
    isLoading,
    error,
    isPlaceholderData,
  };
}
